import React from 'react'
import { Typography, Box, Grid } from '@mui/material'

export default function BrandProfiles() {
  const params = [
    {
      bgColor: '#27529B',
      bgImage: 'GY_BG',
      order: 0,
      logo: 'GY',
      text: `Goodyear is a globally recognized tyre manufacturer, synonymous with innovation, quality, and performance. Founded in 1898, the brand has become a symbol of reliability, creating products designed to enhance safety and optimize performance across a diverse range of vehicles. Goodyear stands for more than just tyres; it embodies a commitment to pushing the boundaries of technology, sustainability, and customer satisfaction.`,
    },
    {
      bgColor: '#7F1084',
      bgImage: 'NX_BG',
      order: 1,
      logo: 'NX',
      text: `NEXEN Tire was established in 1942, embodying a spirit of progress and excellence, prioritizing cutting-edge technologies and customer-centric design. With a commitment to safety, durability, and environmental sustainability, NEXEN develops tyres that meet the needs of modern mobility. NEXEN Tire is a globally respected tyre manufacturer known for blending innovation, quality, and value to deliver exceptional products for various vehicles.`,
    },
    {
      bgColor: '#0C4B87',
      bgImage: 'TR_BG',
      order: 0,
      logo: 'TR',
      text: `Triangle Tyres is a leading global tire manufacturer renowned for its innovation, quality, and value-driven products. Established in 1976, the company has built a strong reputation for producing a wide range of tires, including passenger, commercial, and specialty tires. Trusted in over 180 countries, Triangle Tyres represents a commitment to excellence and a vision for driving progress in the global tire industry.`,
    },
  ]

  return (
    <Box mt={10}>
      {params.map((param, index) => (
        <Grid container key={index}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              backgroundColor: param.bgColor,
              backgroundImage: `url("/assets/BrandProfiles/${param.bgImage}.png")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              minHeight: { xs: 300, md: 400 },
              order: { xs: 1, md: param.order },
            }}
          />
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              backgroundColor: param.bgColor,
              padding: { xs: 3, md: 10 },
              minHeight: { xs: 300, md: 400 },
            }}
          >
            <Box
              sx={{
                backgroundImage: `url("/assets/BrandProfiles/${param.logo}.png")`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: { xs: 100, md: 200 },
              }}
            />
            <Typography color='white' textAlign='justify'>
              {param.text}
            </Typography>
          </Grid>
        </Grid>
      ))}
    </Box>
  )
}
